import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en';
import fr from './locales/fr';

// Get locale from URL params — default French when host omits locale
const params = new URLSearchParams(window.location.search);
const locale = params.get('locale') || 'fr-ca';

// Map locale codes to language (en-ca -> en, fr-ca -> fr)
const language = locale.startsWith('en') ? 'en' : 'fr';

i18n.use(initReactI18next).init({
  lng: language,
  fallbackLng: 'fr',
  resources: {
    en: {
      translation: en,
    },
    fr: {
      translation: fr,
    },
  },
  interpolation: {
    escapeValue: false, // React already escapes
  },
  react: {
    useSuspense: false, // Disable suspense to avoid loading issues
  },
});

export default i18n;
